import { render, staticRenderFns, recyclableRender, components } from "./myPolicy.vue?vue&type=template&id=2bf9d446&scoped=true&"
var renderjs
import script from "./myPolicy.vue?vue&type=script&lang=js&"
export * from "./myPolicy.vue?vue&type=script&lang=js&"
import style0 from "./myPolicy.vue?vue&type=style&index=0&lang=css&"
import style1 from "./myPolicy.vue?vue&type=style&index=1&id=2bf9d446&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../soft/HBuilderX.4.08.2024040127/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf9d446",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/myPolicy/myPolicy.vue"
export default component.exports